import axios from "axios";
export default {
    handleLandingLinkClick(context, ev, link) {
        if (window.location.hash.indexOf('landingconfig') >= 0)
            return;
        
        if (link.isCreateLink) {
            ev.stopPropagation();
            ev.preventDefault();
            context.$emit("addDocument", link.createDocType || '');
        } else if (link.url && link.sso) {
            // any sso links should be proxied to append sso token
            ev.stopPropagation();
            ev.preventDefault();

            // ask for sso link from url
            axios
                .post("auth/ssolink", { link: link })
                .then((resp) => {
                    if (!resp.data || !resp.data.url)
                    return alert("Error Creating SSO Link, cannot log you in to alternative resource");
                    window.open(resp.data.url, resp.data.target);
                })
                .catch(() => {
                    alert("Error Creating SSO Link, cannot log you in to alternative resource");
                });
        } else if (link.passedParams && link.url) {
            ev.stopPropagation();
            ev.preventDefault();
            let params;
            try {
                params = JSON.parse(link.passedParams);
                context.$passedParams.set(params);
            } catch (e) {
                console.log(e);
            }

            context.$router.push( { path: link.url });
        }
    },
    //update/validate definition
    prepLandingPageDefinition(definition) {
        const documentType = definition.documentType;
        const definitionDocTypes = definition.docTypes || documentType ? [ documentType ] : [];
        definition.tabs = definition.tabs || [];

        if (definition.tabs.length === 0)
            definition.tabs.push({ title: "New Tab" });

        definition.tabs.forEach((t) => {
            t.cols = t.cols || [];
            if (t.cols.length === 0)
            t.cols.push({
                cols: 0,
                rows: []
            });
            
            //handle old definitions before I added multiple columns
            if (t.rows) {
                t.cols[0].rows = t.rows;
                delete t.rows;
            }
        });

        //handle old definitions before I added tab support
        if (definition.rows) {
            definition.tabs[0].cols[0].rows = definition.rows;
            delete definition.rows;
        }

        definition.tabs.forEach((t) => {
            t.cols.forEach((c) => {
                if (c.margin === undefined)
                    c.margin = "12";
                
                c.rows = c.rows || [];
                c.rows.forEach((r) => {
                    r.controlType = r.controlType || "LinkTiles";
                    r.style = r.style || "static";
                    r.collapsed = (r.style === "collapsible-collapsed");

                    r.cols = r.cols || 12;
                    r.links = r.links || [];
                    const maxId = Math.max(...r.links.map((l) => l.id || 0));
                    r.links.forEach((l, li) => {
                        l.id = l.id || maxId + li + 1;
                        l.type = l.type || "link";
                    });
                    r.docListColumns = r.docListColumns || [];
                    r.taskListColumns = r.taskListColumns || ["due_date","task_type","task_status","reference"];

                    if (r.controlType === 'v3FeedbackStrip') {
                        r.items = r.items || [];
                    }
                    if (r.controlType === 'v3StatRow') {
                        r.tiles = r.tiles || [];
                    }
                    if (r.controlType === 'v3Delegated') {
                        r.limit = r.limit || 6;
                    }
                    if (r.controlType === 'v3AdminPriority') {
                        r.limit = r.limit || 3;
                        r.scope = r.scope || 'all';
                    }
                    if (r.controlType === 'v3AttentionQueue') {
                        r.limit = r.limit || 5;
                        r.scope = r.scope || 'all';
                    }
                    if (r.controlType === 'v3Activity') {
                        r.limit = r.limit || 8;
                        r.days = r.days || 30;
                        r.scope = r.scope || 'all';
                    }
                    if (r.controlType === 'v3PriorityStack') {
                        r.limit = r.limit || 3;
                    }
                    if (r.controlType === 'v3ScoreRing') {
                        r.max = r.max || 100;
                    }
                    if (r.controlType === 'v3LinkList') {
                        r.links = r.links || [];
                    }
                    if (r.controlType === 'v3FeatureTiles') {
                        r.tiles = r.tiles || [];
                    }
                    if (r.controlType === 'v3DocList') {
                        r.limit = r.limit || 8;
                        r.docTypes = r.docTypes || [];
                    }
                    if (r.controlType === 'v3DocListFull') {
                        r.limit = r.limit || 12;
                        r.docTypes = r.docTypes || [];
                        r.statuses = r.statuses || [];
                    }
                    if (r.controlType === 'v3ActionPanel') {
                        r.actions = r.actions || [];
                        r.layout = r.layout === 'tiles' ? 'tiles' : 'buttons';
                    }
                    if (r.controlType === 'v3Stepper') {
                        r.steps = r.steps || [];
                    }
                    if (r.controlType === 'v3Calibration') {
                        r.limit = r.limit || 8;
                    }
                    if (r.controlType === 'v3Audit') {
                        r.gaps = r.gaps || [];
                    }
                    if (r.controlType === 'v3Insights') {
                        r.limit = r.limit || 6;
                    }
                    if (r.controlType === 'v3TaskTable') {
                        r.limit = r.limit || 8;
                        r.manager = r.manager === true;
                        r.scope = r.scope || (r.manager ? 'mine' : 'all');
                        r.docTypes = r.docTypes || [];
                    }
                    if (r.controlType === 'v3DonutChart') {
                        r.mode = r.mode || 'donut';
                        r.dataSource = r.dataSource || 'static';
                        r.segments = r.segments || [];
                        r.apiParams = r.apiParams || [];
                        r.apiFilters = r.apiFilters || [];
                        r.segmentColours = r.segmentColours || [];
                        r.segmentMapping = r.segmentMapping || {
                            labelField: 'status',
                            valueField: 'count',
                            colourField: 'colour',
                        };
                    }
                    if (r.controlType === 'DonutChart') {
                        r.segments = r.segments || [];
                        r.dataSource = r.dataSource || 'static';
                        r.apiParams = r.apiParams || [];
                        r.apiFilters = r.apiFilters || [];
                        r.segmentMapping = r.segmentMapping || {
                            labelField: 'label',
                            valueField: 'value',
                            colourField: 'colour',
                        };
                        r.segmentColours = r.segmentColours || [];
                    }
                    if (r.controlType === 'BarChart' || r.controlType === 'v3BarChart') {
                        r.rows = r.rows || [];
                        r.filters = r.filters || [];
                        r.dataSource = r.dataSource || 'static';
                        r.apiParams = r.apiParams || [];
                        r.rowMapping = r.rowMapping || {
                            labelField: 'label',
                            valueField: 'value',
                        };
                    }

                    if (r.controlType === 'DocumentList' || r.controlType === 'TaskList')
                        r.docTypes = r.docTypes || definitionDocTypes;

                    if (r.controlType === 'DocumentListFull') {
                        r.sortBy = r.sortBy || 'system_number';
                        r.sortDirection = r.sortDirection || 'desc';
                    }

                    if (r.links.some(l => l.type === "metabase"))
                        r.controlType = "Metabase";

                    if (r.controlType === "Metabase") {
                        r.links.forEach(l => {
                            l.showBorder = l.showBorder === undefined || l.showBorder;
                        })
                    }
                })
            });
        });

        definition.defaultTabIndex = definition.defaultTabIndex || 0;
    }
}